import { defineComponent as M, inject as T, computed as o, openBlock as t, createElementBlock as r, normalizeClass as p, createBlock as C, resolveDynamicComponent as h, mergeProps as j, withCtx as H, createElementVNode as i, createVNode as w, unref as l, Fragment as u, createTextVNode as v, createCommentVNode as n, toDisplayString as N } from "vue";
import { $ as z } from "./chunks/FrontiersClibConfigService.5b50b8d0.js";
import { Avatar as b } from "./avatar.es.js";
import './assets/Card.css';import './assets/index22.css';/* empty css                                                      */import { g as V } from "./chunks/getDataEventValue.a20ca383.js";
const I = { class: "CardEditor__info" }, $ = { class: "CardEditor__mask" }, B = { class: "CardEditor__detail notranslate" }, U = ["innerHTML"], A = {
  key: 0,
  class: "CardEditor__affiliation__location"
}, D = ["innerHTML"], F = ["innerHTML"], S = {
  key: 0,
  class: "CardEditor__more"
}, G = { class: "CardEditor__role" }, O = { class: "CardEditor__journal" }, R = /* @__PURE__ */ M({
  __name: "CardEditor",
  props: {
    id: {},
    fullName: {},
    role: {},
    profileImageUrl: {},
    journalName: {},
    affiliation: {},
    capitalizeName: { type: Boolean, default: !0 },
    heading: { default: "h3" }
  },
  setup(y) {
    const a = y, s = T("sanitize"), E = o(() => `${z.getLoopUrl}/people/${a.id}`), c = o(() => {
      const e = a.role || "", _ = a.journalName || "";
      return (e.trim() + _.trim()).length > 0;
    }), f = o(() => !!(a.affiliation && a.affiliation.city && a.affiliation.city.length > 0)), d = o(() => !!(a.affiliation && a.affiliation.country && a.affiliation.country.length > 0)), g = o(() => a.fullName.toLowerCase()), m = o(() => {
      const e = parseFloat(a.id);
      return !isNaN(e) && e > 0;
    }), k = o(() => m.value ? "a" : "div"), L = () => {
      let e = {};
      return m.value && (e = Object.assign(e, {
        href: E.value,
        target: "_blank",
        "data-event": V("cardEditor", "a", a.id)
      })), e;
    };
    return (e, _) => (t(), r("article", {
      class: p(["CardEditor", { "CardEditor--noMoreInfo": !c.value }])
    }, [
      (t(), C(h(k.value), j({ class: "CardEditor__wrapper" }, L()), {
        default: H(() => [
          i("div", I, [
            i("figure", $, [
              w(l(b), {
                fullName: e.fullName,
                src: e.profileImageUrl,
                color: "Grey"
              }, null, 8, ["fullName", "src"])
            ]),
            i("div", B, [
              (t(), C(h(e.heading), {
                class: p(["CardEditor__name", { "CardEditor__name--capitalized": e.capitalizeName }]),
                innerHTML: l(s)(e.capitalizeName ? g.value : e.fullName)
              }, null, 8, ["class", "innerHTML"])),
              e.affiliation ? (t(), r(u, { key: 0 }, [
                i("p", {
                  class: "CardEditor__affiliation__name",
                  innerHTML: l(s)(e.affiliation.name)
                }, null, 8, U),
                f.value || d.value ? (t(), r("p", A, [
                  i("span", {
                    innerHTML: l(s)(e.affiliation.city)
                  }, null, 8, D),
                  f.value && d.value ? (t(), r(u, { key: 0 }, [
                    v(", ")
                  ], 64)) : n("", !0),
                  d.value ? (t(), r("span", {
                    key: 1,
                    innerHTML: l(s)(e.affiliation.country)
                  }, null, 8, F)) : n("", !0)
                ])) : n("", !0)
              ], 64)) : n("", !0)
            ])
          ]),
          c.value ? (t(), r("div", S, [
            i("p", G, N(e.role), 1),
            i("p", O, [
              e.journalName ? (t(), r(u, { key: 0 }, [
                v(N(e.journalName), 1)
              ], 64)) : n("", !0)
            ])
          ])) : n("", !0)
        ]),
        _: 1
      }, 16))
    ], 2));
  }
});
export {
  R as CardEditor
};
